import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
//import { getBasePath } from './pathUtils'; // Optional helper

// For Azure deployment, we need to handle different base paths
const getLoadPath = () => {
    // If using CRA, this will be set automatically
    if (process.env.PUBLIC_URL) {
        return `${process.env.PUBLIC_URL}/locales/{{lng}}/translation.json`;
    }

    // For Azure deployments with custom domains
    if (window.location.hostname === 'apps.symcarelab.com') {
        return '/locales/{{lng}}/translation.json';
    }

    // Default local development path
    return '/locales/{{lng}}/translation.json';
};

i18n.use(HttpApi)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        supportedLngs: ['en', 'fr', 'de'],
        fallbackLng: 'fr',
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: getLoadPath(),
            requestOptions: {
                cache: 'no-store', // Prevent caching issues in Azure
            },
        },
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'navigator'],
            caches: ['cookie'],
        },
    });

// Add error handling
i18n.on('failedLoading', (lng, ns, msg) => {
    console.error(`Failed to load ${lng} translations:`, msg);
    // Fallback to French if loading fails
    if (lng !== 'fr') {
        i18n.changeLanguage('fr');
    }
});

export default i18n;
